import { useState } from 'react'
import { LocalIcon, Text } from '~/shared/ui'
import type { OptiSuggestion } from '../lib/types'

interface OptiSuggestionCardProps {
  suggestion: OptiSuggestion
}

export function OptiSuggestionCard({ suggestion }: OptiSuggestionCardProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <LocalIcon
          name="opti"
          size="18"
          className="text-content-medium-emphasis"
        />
        <Text appearance="BODY2">opti Suggestion and Reasoning</Text>
      </div>
      <div>
        <Text
          appearance="BODY2"
          className="text-teal-700"
        >
          <LocalIcon
            name="wbIncandescent"
            size="14"
            className="mr-1 inline-block align-text-bottom text-teal-700"
          />
          {suggestion.code} - {suggestion.description}
        </Text>
        <Text
          appearance="CAPTION"
          className={`mt-1 text-sm ${isExpanded ? '' : 'line-clamp-3'}`}
        >
          {suggestion.reasoning}
        </Text>
        {suggestion.reasoning.length > 150 && (
          <button
            type="button"
            className="text-primary-main mt-0.5 cursor-pointer border-none bg-transparent p-0 text-xs font-medium"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Show less' : 'Show more'}
          </button>
        )}
      </div>
      {suggestion.extractedQuotes.length > 0 && (
        <div className="flex flex-col gap-2">
          <Text
            appearance="OVERLINE"
            className="text-content-medium-emphasis"
          >
            Extracted Quotes
          </Text>
          <div className="flex flex-wrap gap-2">
            {suggestion.extractedQuotes.map((quote) => (
              <span
                key={quote}
                className="inline-flex w-fit items-center gap-1.5 rounded-lg border border-dashed border-[#BD9700] bg-[#FFFAE5] px-2.5 py-1 text-sm"
              >
                <LocalIcon
                  name="formatQuote"
                  size="16"
                  className="text-[#BD9700]"
                />
                <span className="text-[#8F7200]">{quote}</span>
              </span>
            ))}
          </div>
        </div>
      )}
      {suggestion.isDenied && (
        <span className="inline-flex w-fit items-center gap-1.5 rounded-lg border border-dashed border-[#BD9700] bg-[#FFFAE5] px-2.5 py-1 text-sm">
          <LocalIcon
            name="formatQuote"
            size="16"
            className="text-[#BD9700]"
          />
          <span className="text-[#8F7200]">denied</span>
        </span>
      )}
    </div>
  )
}
